import { createApp } from "vue";
import App from "./App.vue";

import "./app.scss";

import vuetify from "./plugins/vuetify";
import hotkey from "./directives/hotkey";
import VideoEmbed from "./components/VideoEmbed.vue";

import router from "./router";
import { store } from "./store";

// Maps load on demand (services/GoogleMapsLoader.service.js) when a page shows one.
if (!process.env.VUE_APP_GOOGLE_MAPS_KEY) {
  console.warn("VUE_APP_GOOGLE_MAPS_KEY environment variable is not set. Google Maps will not be available.");
}

createApp(App)
  .use(vuetify)
  .use(store)
  .use(router)
  .directive("hotkey", hotkey)
  .component("VideoEmbed", VideoEmbed)
  .mount("#app");
